import React from 'react';
import { PropTypes } from 'prop-types';
import Modal from '../../components/Modal';

const ViewImage = ({ img, visible, onCancel }) => {
  return (
    <Modal
      open={Boolean(visible)}
      width="auto"
      onCancel={onCancel}
      closable={true}
    >
      <div
        style={{
          width: '100%',
          maxHeight: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          id="region-select-canvas"
          alt="imgModal"
          src={img}
          width="100%"
          style={{ maxHeight: '80vh', width: 'auto' }}
        />
      </div>
    </Modal>
  );
};

ViewImage.propTypes = {
  img: PropTypes.string,
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
};

ViewImage.defaultProps = {
  visible: false,
  onCancel: () => {},
  img: undefined,
};
export default ViewImage;
